import * as yup from "yup";

import { useState, useEffect } from "react";
import { IoPlayOutline, IoReload } from "react-icons/io5";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import ReactSelect from "./../../../components/common/ReactSelect";
import Datepicker from "./../../../components/common/Datepicker";

import invoiceService from "../../../services/invoiceService";
import moment from "moment";

const schema = yup.object();

const InvoicesFilter = ({ options, onFilter }) => {
  const [year, setYear] = useState(null);
  const [month, setMonth] = useState(null);

  const statuses = invoiceService.getInvoiceStatuses();
  const postings = invoiceService.getInvoicePostings();

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    control,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = (info) => {
    const status =
      info.status && info.status !== undefined ? info.status.value : "";

    const posted =
      info.posted && info.posted !== undefined ? info.posted.value : "";

    const year =
      info.year && info.year !== undefined
        ? moment(info.year, "MM-DD-yyyy").year()
        : "";
    const month =
      info.month && info.month !== undefined
        ? moment(info.month, "MM-DD-yyyy").month() + 1
        : "";
    const date = "";

    onFilter(status, posted, year, month, date);
  };

  const handleReset = () => {
    const status = "";
    const posted = "";
    const year = "";
    const month = "";
    const date = "";

    onFilter(status, posted, year, month, date);
  };

  useEffect(() => {
    if (options) {
      const { status, posted, year, month } = options;

      const today = moment();
      const statuses = invoiceService.getInvoiceStatuses();
      const selected_status = statuses.filter((i) => i.value === status);

      const postings = invoiceService.getInvoicePostings();
      const selected_postings = postings.filter((i) => i.value === posted);

      if (year !== "") {
        const formatted_year = moment([year, today.month(), today.date()]);

        setValue("year", formatted_year);
        setYear(formatted_year);
      }

      if (month) {
        const formatted_month = moment([today.year(), month - 1, today.date()]);

        setValue("month", formatted_month);
        setMonth(formatted_month);
      }

      setValue("status", selected_status[0]);
      setValue("posted", selected_postings[0]);
    }
  }, [options, setValue]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8 space-y-6">
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <ReactSelect
            id="status-dropdown"
            name="status"
            title="Status"
            options={statuses}
            control={control}
            register={register("status")}
            errors={errors}
            isClearable
          />
        </div>
      </div>
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <ReactSelect
            id="posted-dropdown"
            name="posted"
            title="Posting"
            options={postings}
            control={control}
            register={register("posted")}
            errors={errors}
            isClearable
          />
        </div>
      </div>
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <Datepicker
            id="year-datepicker"
            name="year"
            title="Year"
            dateFormat="YYYY"
            setValue={setValue}
            clearErrors={clearErrors}
            register={register("year")}
            timeFormat={false}
            onDateChange={(date) => setYear(date)}
            value={year}
            errors={errors}
            isOpen={false}
            readOnly
          />
        </div>
      </div>
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <Datepicker
            id="month-datepicker"
            name="month"
            title="Month"
            dateFormat="MMMM"
            setValue={setValue}
            clearErrors={clearErrors}
            register={register("month")}
            timeFormat={false}
            onDateChange={(date) => setMonth(date)}
            value={month}
            errors={errors}
            isOpen={false}
            readOnly
          />
        </div>
      </div>
      <div className="grid grid-cols-5 gap-2 pt-5">
        <div className="col-span-2">
          <button
            type="button"
            onClick={handleReset}
            className="button bg-gray-200 text-gray-500"
          >
            Reset <IoReload className="ml-2" />
          </button>
        </div>
        <div className="col-span-3">
          <button type="submit" className="button button-primary">
            Apply Filter <IoPlayOutline className="ml-2" />
          </button>
        </div>
      </div>
    </form>
  );
};

export default InvoicesFilter;
